export const MARKER_END = 'MARKER_END'